export const {
    VITE_FRONTEND_HOST: FRONTEND_HOST,
    VITE_API_HOST: API_HOST,
    VITE_ADMIN_CONTACT: ADMIN_CONTACT,
    VITE_GA_ID: GA_ID,
} = import.meta.env;
